export default "__VITE_ASSET__b8299813__"